import { render } from "./AppEmployeeDossier.vue?vue&type=template&id=2d6010e4&scoped=true"
import script from "./AppEmployeeDossier.vue?vue&type=script&lang=js"
export * from "./AppEmployeeDossier.vue?vue&type=script&lang=js"

import "./AppEmployeeDossier.vue?vue&type=style&index=0&id=2d6010e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6010e4"]])

export default __exports__